const pubsub = require('../utils/pubsub');

const CLOSE_BUTTON_CLASS = 'advert-closeBtn',
	SVG_CLOSE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 15 15"><path d="M3.25,3.25l8.5,8.5M11.75,3.25l-8.5,8.5"></path></svg>',
	STYLES = `
.${CLOSE_BUTTON_CLASS} {
	display: none;
	position: absolute;
	left: calc(100% - 10px);
	bottom: calc(100% - 10px);
	width: 20px;
	height: 20px;
	padding: 0;
	background: #fff;
	border: 1px solid #eee;
	border-radius: 50%;
	stroke: #000;
	cursor: pointer;
}

[data-advert-slot-state="rendered"] > .${CLOSE_BUTTON_CLASS} {
	display: block;
}
`.replace(/[\t\n]/g, '');

function init(slotManager) {
	const closeableSlots = slotManager.getSlots().filter((s) => s.closeable);

	if (closeableSlots.length > 0) {
		_addStyling();
	}

	closeableSlots.forEach((cSlot) => {
		pubsub.subscribe(`slot.${cSlot.name}.rendered`, (slot) => {
			if (!slot.isEmpty) {
				setTimeout(() => {
					_addCloseButtonIfMissing(slot);
				}, 100); // Minor delay because Google sometimes rushes the event
			}
		});
	});
}

function _addStyling() {
	const styleTag = document.createElement('style');

	styleTag.innerHTML = STYLES;
	document.head.appendChild(styleTag);
}

function _addCloseButtonIfMissing(slot) {
	if (slot.node.querySelector('.' + CLOSE_BUTTON_CLASS) === null) {
		const button = document.createElement('button');

		button.className = CLOSE_BUTTON_CLASS;
		button.setAttribute('aria-label', 'close ad');
		button.innerHTML = SVG_CLOSE_ICON;
		button.addEventListener('click', () => {
			slot.node.innerHTML = '';
			slot.node.removeAttribute('style');
		});
		slot.node.appendChild(button);
	}

	const computedPosition = window.getComputedStyle(slot.node).getPropertyValue('position');

	if (!computedPosition || computedPosition === 'static') {
		slot.node.style.position = 'relative';
	}
}

module.exports = {
	init
};
